import { Controller } from '@hotwired/stimulus';

/**
 * Role change controller — shows self-demotion warning when current user
 * selects 'collaborator' for themselves in the role change modal.
 */
export default class extends Controller {
  static targets = ['warning', 'assignmentInfo'];
  static values = { selfDemotion: Boolean };

  toggle(event) {
    const selectedRole = event.target.value;
    const isNonAdmin = selectedRole !== 'admin';

    if (this.selfDemotionValue && this.hasWarningTarget) {
      this.warningTarget.classList.toggle('hidden', !isNonAdmin);
    }

    if (this.hasAssignmentInfoTarget) {
      this.assignmentInfoTarget.classList.toggle('hidden', isNonAdmin);
    }
  }
}
